import { Pipe, PipeTransform } from '@angular/core';
import { ArrangementType } from './models/arrangement';

/**
 * Swaps "Deceased" wording for "Prepaid Client" on prepaid arrangements.
 *
 * PURE, keyed on the arrangement TYPE VALUE (a string), not the Arrangement
 * object: the impure version re-ran an _.get walk plus two regex passes at 42
 * template sites on EVERY change-detection pass (2026-09-04 audit) - the
 * single cheapest hot-path fix in the form partials. Angular now re-runs it
 * only when the text or the type value actually changes.
 */
@Pipe({
  name: 'clientTypeName',
})
export class ClientTypeNamePipe implements PipeTransform {
  transform(text?: string | null, arrangementType?: string | null): string {
    const value = text ?? '';

    if (arrangementType === ArrangementType.PrePaid) {
      return value.replace(/Deceased/g, 'Prepaid Client').replace(/deceased/g, 'prepaid client');
    }

    return value.replace(/Prepaid Client/g, 'Deceased').replace(/prepaid client/g, 'deceased');
  }
}
